import { render } from "./MyPays.vue?vue&type=template&id=bbfa6886&ts=true"
import script from "./MyPays.vue?vue&type=script&lang=ts"
export * from "./MyPays.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__